import React from "react";
import FormWrapper from "../../ServeToThrive/shared/FormWrapper";
import ProgressBar from "../../ServeToThrive/shared/ProgressBar";

const skillOptions = [
  { value: "speaking", label: "Speaking / Preaching" },
  { value: "music", label: "Music / Worship Leading" },
  { value: "teaching", label: "Teaching / Training" },
  { value: "youth", label: "Youth Ministry" },
  { value: "children", label: "Children's Ministry" },
  { value: "pastoral", label: "Pastoral Care / Counselling" },
  { value: "admin", label: "Administration" },
  { value: "tech", label: "Tech / AV / Production" },
  { value: "events", label: "Events & Hospitality" },
  { value: "outreach", label: "Outreach & Evangelism" },
  { value: "prayer", label: "Prayer Ministry" },
  { value: "mentoring", label: "Mentoring / Discipleship" },
];

export default function SkillsNeeded({ formData, onInputChange, onContinue, onBack, stepNumber, totalSteps }) {
  const selected = formData.skillsNeeded || [];

  const toggle = (value) => {
    const current = formData.skillsNeeded || [];
    onInputChange("skillsNeeded", current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value]
    );
  };

  return (
    <FormWrapper>
      <button onClick={onBack} style={{ display: "flex", alignItems: "center", gap: "6px", padding: "8px 12px", fontSize: "14px", fontWeight: "500", color: "#737373", backgroundColor: "transparent", border: "none", cursor: "pointer", marginBottom: "8px" }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#1a1a1a")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#737373")}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
        Back
      </button>

      <ProgressBar currentStep={stepNumber} totalSteps={totalSteps} />

      <div style={{ textAlign: "center", marginBottom: "32px", animation: "fadeInUp 0.5s ease" }}>
        <div style={{ width: "48px", height: "48px", backgroundColor: "#f3f4f6", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", border: "1px solid #e5e7eb" }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#36454F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </div>
        <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1a1a1a", marginBottom: "8px", letterSpacing: "-0.5px" }}>
          What skills are you looking for?
        </h1>
        <p style={{ fontSize: "15px", color: "#737373", margin: 0 }}>
          Select the kinds of help your church or event needs
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "10px", marginBottom: "24px", animation: "fadeInUp 0.5s ease 0.1s both" }}>
        {skillOptions.map((option) => {
          const isSelected = selected.includes(option.value);
          return (
            <button key={option.value} onClick={() => toggle(option.value)}
              style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px", fontSize: "13px", fontWeight: "500", color: isSelected ? "#1a1a1a" : "#525252", backgroundColor: isSelected ? "#f3f4f6" : "#fff", border: isSelected ? "1px solid #36454F" : "1px solid #e5e5e5", borderRadius: "8px", cursor: "pointer", transition: "all 0.2s ease", textAlign: "left" }}
              onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.borderColor = "#36454F"; }}
              onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.borderColor = "#e5e5e5"; }}>
              <div style={{ width: "18px", height: "18px", borderRadius: "4px", border: isSelected ? "none" : "1.5px solid #d1d5db", backgroundColor: isSelected ? "#36454F" : "transparent", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                {isSelected && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>}
              </div>
              <span style={{ flex: 1, lineHeight: "1.3" }}>{option.label}</span>
            </button>
          );
        })}
      </div>

      {selected.length > 0 && (
        <p style={{ textAlign: "center", fontSize: "13px", color: "#525252", marginBottom: "24px", fontWeight: "500" }}>
          {selected.length} skill{selected.length !== 1 ? "s" : ""} selected
        </p>
      )}

      <button onClick={onContinue} disabled={selected.length === 0}
        style={{ width: "100%", padding: "16px 24px", fontSize: "16px", fontWeight: "600", color: "#fff", backgroundColor: selected.length > 0 ? "#1a1a1a" : "#d4d4d4", border: "none", borderRadius: "8px", cursor: selected.length > 0 ? "pointer" : "not-allowed", transition: "all 0.2s ease", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
        onMouseEnter={(e) => { if (selected.length > 0) { e.currentTarget.style.backgroundColor = "#333"; e.currentTarget.style.transform = "translateY(-1px)"; } }}
        onMouseLeave={(e) => { if (selected.length > 0) { e.currentTarget.style.backgroundColor = "#1a1a1a"; e.currentTarget.style.transform = "translateY(0)"; } }}>
        Continue
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
      </button>
    </FormWrapper>
  );
}
